import styled from 'styled-components';
import React, { useContext, useState } from 'react';
import { ConnectedAccountContext } from '@/contexts';
import { Button, FlexRow, HeaderText, PageTile } from '@make-software/cspr-design';

import { Container, MessageTable, SendMessageModal } from '@/components';

import { useGetMessagesSentByAccount } from '@/hooks';

const PageContentSection = styled.section(({ theme }) =>
  theme.withMedia({
    maxWidth: ['100%', '720px', '1200px'],
    width: '100%',
    margin: '0 auto',
    padding: '0 12px',
    paddingTop: '48px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  })
);

const HeaderRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  })
);

const HeaderButton = styled(Button)(({ theme }) =>
  theme.withMedia({
    cursor: 'pointer',
    width: '176px',
    height: '36px',
  })
);

const OutboxScene = () => {
  const [showComposeMessageModal, setShowComposeMessageModal] = useState<boolean>(false);
  const { connectedAccount } = useContext(ConnectedAccountContext);

  if (!connectedAccount) {
    return null;
  }

  return (
    <Container>
      <PageContentSection>
        <HeaderRow>
          <HeaderText size={2}>Sent</HeaderText>
          <HeaderButton onClick={() => setShowComposeMessageModal(true)}>
            Compose
          </HeaderButton>
        </HeaderRow>

        <PageTile>
          <MessageTable dataLoader={(page: number, perPage: number) =>
            useGetMessagesSentByAccount(connectedAccount.public_key, page, perPage)
          } />
        </PageTile>

        <SendMessageModal
          isOpen={showComposeMessageModal}
          onClose={() => setShowComposeMessageModal(false)}
        />
      </PageContentSection>
    </Container>
  );
};

export default OutboxScene;
